// extracted by mini-css-extract-plugin
export var aboveInput = "_jo-0";
export var actionButton = "_jo-5";
export var actionButtonContainer = "_jo-1";
export var actionIcon = "_jo-6";
export var aiInfoContainer = "_jo-2";
export var attachmentWrapper = "_jo-7";
export var bold = "_jo-3";
export var checkIcon = "_jo-8";
export var clickingRecipientBar = "_jo-11";
export var commentThreadSwitch = "_jo-a";
export var draftImage = "_jo-b";
export var draftImageContainer = "_jo-c";
export var draftImages = "_jo-e";
export var editButton = "_jo-g";
export var editor = "_jo-f";
export var editorContainer = "_jo-y";
export var editorErrorTooltipWrapper = "_jo-9";
export var headerDivider = "_jo-h";
export var icon = "_jo-i";
export var info = "_jo-j";
export var internal = "_jo-n";
export var internalDivider = "_jo-k";
export var internalMessage = "_jo-l";
export var messageInputCard = "_jo-m";
export var messageInputForm = "_jo-o";
export var messageInputFormInternal = "_jo-p";
export var options = "_jo-q";
export var publicMessageCustomer = "_jo-s";
export var publicMessageMerchant = "_jo-r";
export var removeImageButton = "_jo-d";
export var replyButtons = "_jo-t";
export var showSignatureButton = "_jo-u";
export var spinner = "_jo-v";
export var verticalButtonDivider = "_jo-4";
export var visibilitySelector = "_jo-w";
export var warning = "_jo-x";
export var wrappingText = "_jo-z";
export var writingInternalNoteTopBorder = "_jo-10";